// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

	/* Change of season */
	let toggle_season = document.querySelector('#toggle-season');
	let visit_content = document.querySelector('.visit-content');
	if(toggle_season){
		changeSeason( currentSeason );
		if(currentSeason == "summer"){
			toggle_season.checked = true;
			visit_content.querySelector('.season-winter').classList.remove('true');
			visit_content.querySelector('.season-summer').classList.add('true');
		}
		toggle_season.addEventListener( "change", (e) => {
			let value = e.target.checked;
			if(value){
				changeSeason( "summer" );
				visit_content.querySelector('.season-winter').classList.remove('true');
				visit_content.querySelector('.season-summer').classList.add('true');
			}
			else {
				changeSeason( "winter" );
				visit_content.querySelector('.season-winter').classList.add('true');
				visit_content.querySelector('.season-summer').classList.remove('true');
			}
		});
	}

	if(!(window.ActiveXObject) && "ActiveXObject" in window) {

		/*is explorer*/
		function msieversion() {
			let ua = window.navigator.userAgent;
			let msie = ua.indexOf("MSIE ");
			if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
			{
				const image_fit = document.getElementsByClassName('image-fit__wrapper');
				for(let i = 0; i < image_fit.length; i++ ){
					const this_image = image_fit[i].getElementsByTagName('img')[0];
					const image_data = this_image.dataset.srcset;
					const image_src = this_image.getAttribute('src');
					image_fit[i].classList.add('ie-bg');
					if(image_data){
						image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
					}else{
						image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
					}

				}
			}
			else
			{
				console.log('other browser');
			}
			return false;
		}
		msieversion();

	} else {
		/*****************************************************
		OBSERVER TO ADD PARALLAX EFFECT
		*****************************************************/
		let scrollParallax = []
		let scrolled = 0

		/* screen height */
		let v_height = window.innerHeight
			|| document.documentElement.clientHeight
			|| document.body.clientHeight;

		function doParallax(elm) {

			let boundes = elm.dataset.parallax.split(",") /* get it from html */
			/*get distance in positive value*/
			let distance = Math.abs(boundes[0] - boundes[1])
			if (boundes[0] > boundes[1]) {
				/*get distance in negative value (to do the scroll inverse)*/
				distance = distance * -1
			}
			/*Equivalent distance using screen height + element height*/
			const unit_scroll = distance / (v_height + elm.offsetHeight)
			let temp = 0

			let topElement = 0;
			let element = elm;

			let id_elem = elm.dataset.parallaxid

			do {
				topElement += element.offsetTop || 0;
				element = element.offsetParent;
			} while (element)

			let parallaxFunction = function () {
				/*Obtain the distance between top screen and document top 0*/
				scrolled = document.documentElement.scrollTop || window.pageYOffset
				/*Distance of bottom page to top of the element*/
				let relative_distance = scrolled + v_height - topElement
				/*transpoling data to move the parallax element relative to the scroll of all the screen*/
				temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
				/*console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)*/
				elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
			}

			scrollParallax[id_elem] = parallaxFunction

			window.addEventListener('scroll', scrollParallax[id_elem])

		}

		let observers_parallax = document.querySelectorAll(".js-parallax-element")

		if (observers_parallax) {
			let options_parallax = {
				root: null, /* relative to document viewport */
				rootMargin: '0px', /* margin around root. Values are similar to css property. Unitless values not allowed */
				threshold: 0 /* visible amount of item shown in relation to root */
			}

			function handler_parallax(entries, observer) {
				let entry;
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						doParallax(entry.target)
					} else {
						let id_elem = entry.target.dataset.parallaxid
						window.removeEventListener('scroll', scrollParallax[id_elem])
					}
				})
			}

			let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
			let counter = 1
			observers_parallax.forEach(function (element) {
				observable_parallax.observe(element)
				element.dataset.parallaxid = counter
				counter++
			})
		}
		/********************************************************************************
		END OF OBSERVER TO ADD PARALLAX EFFECT
		***********************************************************************************/
	}

	/* Text and Form Animations */
	let formModule = document.querySelectorAll('.form-module-wrapper form');
	let textModule = document.querySelectorAll('.text-modules-wrapper .text-modules');
	if(formModule){
		formModule.forEach(function(form_module) {
			form_module.classList.add('animate-fade', 'top');
		});
	}
	if(textModule){
		textModule.forEach(function(text_module) {
			text_module.classList.add('animate-fade', 'top');
		});
	}

	/* Menu Site */
	let Body = document.body;

	document.addEventListener('DOMContentLoaded', () => {

		$(".errorMsg").slideUp();

		/* Main Nav Dropdown */
		let primaryNav = document.getElementById('primary-nav');
		if(primaryNav){
			primaryNav.querySelectorAll('li').forEach(function(primary_nav) {
				if(primary_nav.querySelector('ul.submenu')){
					primary_nav.querySelector('a').classList.add('has-submenu');
				}
				primary_nav.addEventListener("mouseover", (event) => {
					primary_nav.classList.add('hover');
					if(primary_nav.querySelector('ul.submenu')){
						primary_nav.querySelector('ul.submenu').classList.add('open');
					}
				});
				primary_nav.addEventListener("mouseout", (event) => {
					primary_nav.classList.remove('hover');
					if(primary_nav.querySelector('ul.submenu')){
						primary_nav.querySelector('ul.submenu').classList.remove('open');
					}
				});
			});
		}

		let secondaryNav = document.getElementById('secondary-header-ul_nav');
		if(secondaryNav){
			secondaryNav.querySelectorAll('li').forEach(function(secondary_nav) {
				secondary_nav.addEventListener("mouseover", (event) => {
					secondary_nav.classList.add('hover');
					if(secondary_nav.querySelector('ul.submenu')){
						secondary_nav.querySelector('ul.submenu').classList.add('open');
					}
				});
				secondary_nav.addEventListener("mouseout", (event) => {
					secondary_nav.classList.remove('hover');
					if(secondary_nav.querySelector('ul.submenu')){
						secondary_nav.querySelector('ul.submenu').classList.remove('open');
					}
				});
			});
		}

		/* Lightbox Gallerys */
		const customLightbox = new LBX('.js-lbx-gallery', {
			customClass:'lbx-gallery',
		});

		const jsLbxFloorPlan = new LBX('.js-lbx-floorplan', {
			customClass:'lbx-floorplan',
		});

		/* Lightbox Gallerys */
		const defaultLightbox = new LBX('.js-lbx-default', {
			beforeShow: function () {
				let lightboxSliders = document.querySelectorAll('.images-l-sliders');
				if(lightboxSliders){
					lightboxSliders.forEach(()=>{
						new Swiper('.images-l-sliders', {
							rewind: true,
							effect: "fade",
							fadeEffect: {
								"crossFade": true
							},
							navigation: {
								nextEl: ".sw-but-img-next",
								prevEl: ".sw-but-img-prev",
							},
						});
					});
				}
			},
		});

		
		if( document.querySelector( ".forgot" ) ){
			let forgot_btn = document.querySelector( ".forgot" );
			let loginForm = document.querySelector( "#loginForm" );
			let forgotForm = document.querySelector( "#forgotForm" );

			forgot_btn.addEventListener( "click", (e) => {
				e.preventDefault()
				loginForm.classList.add( "hidden" )
				forgotForm.classList.remove( "hidden" )
				
				loginForm.querySelectorAll('.errorMsg').forEach(error => { error.classList.add('hidden') });

			} )
			
		}

	});

	window.addEventListener("load", function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		});
	});

	/* Remove empty <p> tags created by tinymce */
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	/* Scroll Intro*/
	let ScrollDown = document.getElementsByClassName('js-scrolldown');
	if(ScrollDown.length > 0){
		ScrollDown[0].addEventListener('click', function(){
			animateto('intro');
		});
	}

	/* FAQ */
	let tabLabel = document.querySelectorAll('.tab-label');
    if(tabLabel){
        tabLabel.forEach(entry => {
            let thisHeightTap = entry.clientHeight;
            let thisHeight = entry.nextElementSibling.clientHeight + thisHeightTap;
            entry.parentElement.style.height = thisHeightTap+'px';
            if(entry.classList.contains('open')){
                entry.parentElement.style.height = thisHeight+'px';
            }
            entry.addEventListener('click', function(event){
                let currentclick = this;
                if(!this.classList.contains('open')){
                    tabLabel.forEach(ent => {
                        if(ent !== currentclick){
                            if(ent.classList.contains('open')){
                                ent.classList.remove('open');
                                ent.parentElement.style.height = thisHeightTap+'px';
                            }
                        }
                    });
                    this.classList.add('open');
                    this.parentElement.style.height = thisHeight+'px';
                } else {
                    this.classList.remove('open');
                    this.parentElement.style.height = thisHeightTap+'px';
                }
            });
        });
    }

	/*MOBILE MENU NAV
    ****************************************************************/

	let Html = document.getElementsByTagName('html')[0];
	let MenuBtn = document.getElementById('menu-btn');
	let CloseMenu = document.querySelectorAll('.close-menu');
	let Navigation = document.querySelectorAll('.navigation');
	let NavUl = document.querySelectorAll('.navigation .inner ul li');
	let NavA = document.querySelectorAll('.navigation .inner ul li a');
	let NavActive = document.querySelectorAll('.navigation ul.submenu li .active');

	/* Open Navigation */
	if(MenuBtn){
		MenuBtn.addEventListener('click', function(e){
			Html.classList.add('hide-overflow');
			Navigation[0].classList.add('open');
			NavUl.forEach(function(inner) {
				if(inner.classList.contains('item-open')){
					inner.scrollIntoView(false);
				}
			});
		});

		/* Sub-Navigation */
		/* Open active sub-nav on load */
		NavActive.forEach(function(inner) {
			inner.closest('.inner').classList.add('open');
			inner.parentNode.parentNode.parentNode.parentNode.classList.add('li-open');
			inner.closest('.sub-sub-menu').classList.add('menu-open');
		});

		/* Toggle open/close on tap */
		NavA.forEach(function(entry) {
			if(entry.nextElementSibling){
				entry.classList.add('link-parent');
				let clientChildren = entry.nextElementSibling.querySelector('.submenu');
				if(clientChildren != null){
					let clientHeight = clientChildren.clientHeight;
					if(entry.classList.contains('active') || entry.classList.contains('parent-active')){
						entry.nextElementSibling.classList.add('menu-open');
						entry.nextElementSibling.style.height = clientHeight+'px';
						entry.classList.add('hover-open');
						entry.parentNode.classList.add('li-open');
					}
					entry.addEventListener('click', function(e){
						e.preventDefault();
						if(this.nextElementSibling.classList.contains('menu-open')){
							this.nextElementSibling.classList.remove('menu-open');
							this.nextElementSibling.style.height = '0px';
							this.classList.remove('hover-open');
							this.parentNode.classList.remove('li-open');
						} else {
							NavUl.forEach(function(ul) {
								if(ul.querySelector('.sub-sub-menu')){
									if(ul.querySelector('.sub-sub-menu').classList.contains('menu-open')){
										ul.querySelector('.sub-sub-menu').style.height = '0px';
										ul.querySelector('.sub-sub-menu').classList.remove('menu-open');
										ul.querySelector('.link-parent').classList.remove('hover-open');
										ul.querySelector('.link-parent').parentNode.classList.remove('li-open');
									}
								}
							});
							this.nextElementSibling.classList.add('menu-open');
							this.nextElementSibling.style.height = clientHeight+'px';
							this.classList.add('hover-open');
							this.parentNode.classList.add('li-open');
						}
					});
				}
			}
		});
	}

	/* Close Navigation */
	if(CloseMenu[0]){
		CloseMenu[0].addEventListener('click', function(e){
			Html.classList.remove('hide-overflow');
			Navigation[0].classList.remove('open');
		});
	}

	let notCharge = document.querySelectorAll('.not-charge');
	if (notCharge){
		notCharge.forEach(entry => {
			entry.addEventListener('click', function(event){
				event.preventDefault();
			});
		});
	}

	let screenHeight = document.documentElement.clientHeight;
	let homeTopImg = document.getElementById('home');
	if(homeTopImg){
		homeTopImg.querySelectorAll('.top-img figure, .top-img video').forEach(entry => {
			if(screen.width < 600){
				entry.style.height = screenHeight-65+'px';
			} else {
				entry.style.height = screenHeight-40+'px';
			}
		});
		window.addEventListener("resize", function(){
			screenHeight = document.documentElement.clientHeight;
			homeTopImg.querySelectorAll('.top-img figure, .top-img video').forEach(entry => {
				if(screen.width < 600){
					entry.style.height = screenHeight-65+'px';
				} else {
					entry.style.height = screenHeight-40+'px';
				}
			});
		});
	}
	let aBtn = document.querySelectorAll(".btn:not(:where(.attractions-map__expand, .btn-form, .bookNow)), .signup-btn, .btn-send");
	if(aBtn){
		setTimeout(() => {
			aBtn.forEach(function(a_btn) {
				let htmlString = a_btn.innerText;
                a_btn.innerHTML = '<span>'+htmlString+'</span>';
			});
		}, 500);
	}
	/* Anchor Animation */
	let aHref = document.querySelectorAll("a[href^='#']:not(:where(a[data-fancybox], a.forgot, a[data-lbx], a[data-filter], a.accordion-toggle, a#js_btn_book, a.ui-state-default, .link-parent))");
	if(aHref){
		aHref.forEach(function(a_href) {
			a_href.addEventListener('click', function(e){
				e.preventDefault();
				let strAnchor = this.hash.slice(1);
				animateto(strAnchor);
			});
		});
	}

})();

function animateto(target){
	var gotoTarget = offset(document.getElementById(target)).top - 160;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300;
	var start = new Date().getTime()

	/* Time Interval */
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var y = easeInOutQuart(time, from, to - from, duration)
		} else {

			var y = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, y)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}
/* Ease Movement */
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
/* ScrollW */
function scrollW(){
	/* check scroll down or up for header styles */
	let st = window.pageYOffset || document.documentElement.scrollTop;
	let header = document.getElementById('header');
	let subMenu = document.getElementById('subMenu');
	if(st > 80){
		if (st > lastScrollTop){
			/* downscroll code */
			if(!header.classList.contains('down')){
				header.classList.add('down');
				header.classList.remove('up');
				if(subMenu){
					subMenu.classList.add('down');
					subMenu.classList.remove('up');
				}
			}
		} else {
			/* upscroll code */
			if(!header.classList.contains('up')){
				header.classList.add('up');
				header.classList.remove('down');
				if(subMenu){
					subMenu.classList.add('up');
					subMenu.classList.remove('down');
				}
			}
		}
	} else {
		if(header.classList.contains('up') || header.classList.contains('down')){
			header.classList.remove('up');
			header.classList.remove('down');
			if(subMenu){
				subMenu.classList.remove('up');
				subMenu.classList.remove('down');
			}
		}
	}

	let SubMenu = document.getElementById('subMenuAnchor');
	if(SubMenu){
		let subPost = document.getElementById('subMenu');
		let subPosition = '';
		if(document.body.classList.contains('alert_open')){
			subPosition = offset(SubMenu).top - 156;
		} else {
			if(screen.width < 600){
				subPosition = offset(SubMenu).top - 70;
			} else {
				subPosition = offset(SubMenu).top - 96;
			}
		}
		if(st > subPosition){
			if(!subPost.classList.contains('floating-up')){
				subPost.classList.add('floating-up');
			}
		} else {
			if(subPost.classList.contains('floating-up')) {
				subPost.classList.remove('floating-up');
			}
		}
	}

	lastScrollTop = st <= 0 ? 0 : st; /* For Mobile or negative scrolling */

}
function validationSession(){
	console.log('Start validation Session');
	const rememberMe = localStorage.getItem('remember'),
		username = localStorage.getItem('username');
	if(registerMembers==true && username.length>0){
		console.log('Exists session');
		
	}
	console.log('End validation Session');
}
function registerMembers(e){
	e.preventDefault();
	var extras = {},formId = "registerForm";
	clearErrors(formId);
	formProcessSetup(formId);
	$.post( "/ajax/functions.php",
	{
		operation: 'registerForm',
		email: $("#email").val(),
		firstname: $("#firstname").val(),
		lastname: $("#lastname").val(),
		password: $("#password").val(),
        category: $("#category").val(),
		address: $('#address').val(),
		register_i_gree:$("#register_i_gree").is(":checked"),
		register_subscribe:$("#register_subscribe").is(":checked"),
		_token : $('#_token').val(),
		tr4pValidation:1,
		disabled_welcome_email:'1'
	},
	function(data){
		
		if(data.result == 'success') {
			//extras.page_redirect = '/';
			if( document.URL.indexOf( "friends-and-family-register" ) != "-1" )
				document.location = "/properties";

			showResult(data, formId, extras);

		}else{
			showErrors(data, formId, extras);
		}
	},
	"json"
	);
}

function loginMembers(e){
	e.preventDefault();
	var extras = {},formId = "loginForm";
	clearErrors(formId);
	formProcessSetup(formId);

	// if( $("#username").val() == "" && $("#password").val() == "" ){
	// 	$( ".errorMsg" ).html( "Please fill out all required fields" );
	// 	if(!$("#username").hasClass('error'))$("#username").addClass('error');
	// 	if(!$("#password").hasClass('error'))$("#password").addClass('error');
	// 	$( ".errorMsg" ).show();
	// }else{
	// 	$( ".errorMsg" ).html( "" );
	// 	$( ".errorMsg" ).show();
	// }

	// if( $("#username").val() == "" ){
	// 	if(!$("#username").hasClass('error'))$("#username").addClass('error');
	// 	$( ".username.error-msg" ).removeClass( "hidden" );
	// 	$( ".btnSubmit" ).show();
	// 	return;
	// }else{
	// 	$( ".username.error-msg" ).addClass( "hidden" );
	// }

	// if( $("#password").val() == "" ){
	// 	if(!$("#password").hasClass('error'))$("#password").addClass('error');
	// 	$( ".password.error-msg" ).removeClass( "hidden" );
	// 	$( ".btnSubmit" ).show();
	// 	return;
	// }else{
	// 	$( ".password.error-msg" ).addClass( "hidden" );
	// }

	$.post( "/ajax/functions.php",
	{
		operation: 'loginMembers',
		username: $("#username").val(),
		password: $("#password").val(),
        category: $("#category").val(),
		remember: $("#remember").is(":checked"),
	},
	function(data){
		if(data.result == 'success') {
			localStorage.setItem( "username", data.name );
			localStorage.setItem( "remember",  $("#remember").is(":checked"));

			extras.page_redirect = '/properties';
			document.location = "/properties";
			if(data.warning==1)
				localStorage.setItem('msg',1);
			//showResult(data, formId, extras);
		}else{
			showErrors(data, formId, extras);
		}
	},
	"json"
	);
}

function activeAccount(e){
	e.preventDefault();
    var extras = new Object(),formId = 'activeForm',$processpage = 'ajax/functions.php';;
	extras.dont_hide_form = "1";
    extras.dont_reset_form = "1";

    $("#processing").show();
	$("#btnSubmit").hide();
	
	$('.errorMsg').slideUp();
    $(".errorMsg").html('');

    clearErrors(formId);
    formProcessSetup(formId);
    
    $.post(site_url+$processpage,
        { 
            operation: 'activeAccount', 
            email_reset: $("#email_reset").val(),
            token: $("#token").val(),
            password_reset: $('#password_reset').val(),
            confirm_password : $('#confirm_password').val()
        },function(data){
            if(data.result=='success'){
                //toastr.success('Thank you for your request.');
                $("#email_reset").val('');
                $('#password_reset').val('');
                $('#confirm_password').val('');
                $('#activeForm .errorMsg').slideDown();
				$(".errorMsg").html('Thank you. Your password has been reset. Please save this password for your records.');
				extras.page_redirect = "index.php";
				document.location = "/properties"
				setTimeout(()=>{
					showResult(data,formId,extras);
				},4000);
            }else{
                showErrors(data,formId,extras);
            }
            $("#processing").hide();
        },
        "json"
    );
	

}

function processRecovery(e){
	e.preventDefault();
	var extras = {},formId = "forgotForm";
	clearErrors(formId);
	formProcessSetup(formId);
	$.post( "/ajax/functions.php",
	{
		operation: 'processRecovery',
		email_forgot: $("#email_forgot").val()
	},
	function(data){
		if(data.result == 'success') {
			$("#forgotForm").addClass("hidden");
			$('.forgotForm__success').removeClass("hidden");
		}else{
			console.log(data);
			console.log(formId);
			console.log(extras);
			showErrors(data, formId, extras);
		}
	},
	"json"
	);
}

function showResult(data, formId, extras)
{
	/*extras parameters:
		dont_reset_form = if set will not reset the form
		dont_hide_form = if set will not hide the form
		skip_parent_errors = if set errors will not be placed on the parent elements
		step_content = if set will load up the content  into div
		page_redirect = if set will redirect to the page passed on success
		function_name = if set will call function on form submit success
		use_exact_path = if set will use exact path passed instead of a SITE_ROOT path
		exact_path = path to use for the above option
		dont_scroll_on_error = if set will not scroll to top of page when theres an error
		dont_scroll_on_success = if set will not scroll to top on success
		scrollto = element id to scroll to instead
		clear_errors = if set will clear errors on the form
		dont_hide_buttons = if set will not hide the buttons, use for nested forms.
	*/
	if(extras == undefined) { extras = '' } //check if the extras parameters array exists if not set it so that we dont get errors farther down

	$('#'+formId+' .errorMsg').slideUp();
	$('#'+formId+' .errorMsg').html('');

	if(extras.dont_hide_buttons != '1')
	{
    	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').show();
  		if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+' .btnSubmit').hide();
  	}

  	//check if result is being passed the new way
	var result; //will hold the value for our result success | error

	if(data[0]==undefined) result = data.result;
	else result = data[0].result;

  	if(result=="success")
	{
  		if(extras.dont_reset_form != '1') { resetForm(formId); } //if the dont_reset_form is isnt set then reset the form
		if(extras.step_content != undefined) //check if the ajax page parameter is defined
		{
			//alert('load up via ajax: ' + data[1].step_content);
		   	$("#step_content").hide();	//this has to stay the same because this is where the forms are being loaded into
	   		$("#step_content").load(SITE_ROOT+extras.step_content,function(){
	   			_gaq.push(['_trackPageview', extras.step_content]);

	        	if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+ ' .btnSubmit').show();
	        	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').hide();
	        	$("#step_content").slideDown();}
	        );
	   		if(extras.dont_scroll_on_success != '1')
	        {
		   		if(extras.scrollto != undefined)
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo('#'+extras.scrollto,100,{offset:{top:-20},axis:'y'});
		        	} else {
		        		$.scrollTo('#'+extras.scrollto,800,{offset:{top:-20},axis:'y'});
		        	}
		   		}
		   		else
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo(0,100);
		        	} else {
		        		$.scrollTo(0,800);
		        	}
		   		}
	        }
		}
		else if(extras.page_redirect != undefined) //check if page redirect parameter is passed
		{
			if(extras.use_exact_path =='1')
			{
				document.location = extras.exact_path;
			}
			else
			{
				document.location= extras.page_redirect;
			}
		}
		else if(extras.function_name != undefined)
		{
			eval(extras.function_name)();
		}
		else
		{
			$( ".thankyouMsg" ).html( data.data.message );
			if($('.thankyouMsg').length > 0) $('#'+formId+' .thankyouMsg').slideDown();
			if($('#'+formId).prev(".thankyouMsg").length > 0) $('#'+formId).prev(".thankyouMsg").slideDown();

			if(extras.dont_hide_form != '1')
			{
				if($('#'+formId).length > 0) $("#"+formId).slideUp();
			}
			else
			{
				if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+ ' .btnSubmit').show();
	        	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').hide();
			}
			if(extras.dont_scroll_on_success != '1')
	        {
				if(extras.scrollto != undefined)
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo('#'+extras.scrollto,100,{offset:{top:-20},axis:'y'});
		        	} else {
		        		$.scrollTo('#'+extras.scrollto,800,{offset:{top:-20},axis:'y'});
		        	}
		   		}
		   		else
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo(0,100);
		        	} else {
		        		$.scrollTo(0,800);
		        	}
		   		}
			}
		}
		if(extras.clear_errors == '1')
		{ 	clearErrors(formId);	}
	}
	else
	{
		showErrors(data,formId,extras);
	}

	
}

function showErrors(data,formId,extras){
	clearErrors(formId);

	var newData = new Object();
	if(data[0]==undefined) newData = data;
	else newData = data[0];

	//loop through the JSON array and display the errors
	$.each(newData, function(key,value) {
		if(key != "result"){
			if(extras.add_parent_error != undefined){ 
				if($('#'+key).parent().hasClass("form-entry")) $('#'+key).parent().addClass("error");
			}
			$('label[for='+key+']').addClass("error");
			$('#'+key).addClass("error");
			if($('label[for='+key+']').length>0)
				$( '<span id="'+key+'-error" class="msg error" >This field is required.</span>' ).insertAfter($('label[for='+key+']'));
			else
				$( '<span id="'+key+'-error" class="msg error" >This field is required.</span>' ).insertAfter($('#'+key));
		}
	});
	if($("#"+formId+" .errorMsg").html()=="") {
		//$("#"+formId+" .errorMsg").html("<ul><li>Please correct the errors highlighted in red above.</li></ul>");
		if(newData.errorLogin !== undefined && formId == 'loginForm'){
			$("#"+formId+" .errorMsg").html("<ul><li>"+newData.errorLogin+"</li></ul>");
			if(!$("#username").hasClass('error'))$("#username").addClass('error');
			if(!$("#password").hasClass('error'))$("#password").addClass('error');
		}else if(newData.errorActiveAccount !== undefined && formId == 'activeForm'){
			$("#"+formId+" .errorMsg").html("<ul><li>"+newData.errorActiveAccount+"</li></ul>");
			$('#confirm_password-error').remove();
		}else if(newData.errorProcessRecovery !== undefined && formId == 'forgotForm'){
			$("#"+formId+" .errorMsg").html("<ul><li>"+newData.errorProcessRecovery+"</li></ul>");
			if($('#email_forgot').val()!=='')
				$('#email_forgot-error').remove();
		}else if(newData.errorRegisterForm !== undefined && formId == 'registerForm'){
			$("#"+formId+" .errorMsg").html("<ul><li>"+newData.errorRegisterForm+"</li></ul>");
		}else if(formId !== 'loginForm' && formId !== 'activeForm' && formId !== 'forgotForm'){
			console.log(formId);
			$("#"+formId+" .errorMsg").html("<ul><li>Please correct the errors highlighted in red above.</li></ul>");
		}
			
	} else {
		$("#"+formId+" .errorMsg").html("<ul>"+$("#"+formId+" .errorMsg").html()+"</ul>");
	}
	$("#"+formId+" .errorMsg").slideDown();

	if(extras.dont_scroll_on_error != '1')
	{
		if(extras.scrollto != undefined)
   		{
   			if($('#fbcontent').length > 0) {
        		$('#fancybox-inner').scrollTo('#'+extras.scrollto,100,{offset:{top:-20},axis:'y'});
        	} else {
        		//$.scrollTo('#'+extras.scrollto,800,{offset:{top:-20},axis:'y'});
        	}
   		}
   		else
   		{
   			if($('#fbcontent').length > 0) {
        		$('#fancybox-inner').scrollTo(0,100);
        	} else {
        		//$.scrollTo(0,800);
        	}
   		}
	}

	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').hide();
	if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+' .btnSubmit').show();
}


function clearErrors(formId)  //safari bug is here!!
{
	$('input[type="text"],input[type="password"],input[type="radio"],textarea,select').removeClass("error");
	$('#'+formId+' label').each(function(index){
        if(!$(this).hasClass('errorMsg')) $(this).removeClass("error");
    });

	$('#'+formId+' span').each(function(index){
        if($(this).hasClass('msg error'))$(this).remove();
    });
	
}

function resetForm(formId)
{
	//$('[type="text"]').val("");
	$('#'+formId+' textarea').val("");
	$(':input','#'+formId)
	 .not(':button, :submit, :reset, :hidden, :checkbox , :radio')
	 .val('')
	 .removeAttr('checked')
	 .removeAttr('selected');

	clearErrors(formId);
}
function formProcessSetup(formId)
{
	$('#'+formId+' .errorMsg').slideUp();
	$('#'+formId+' .errorMsg').html('');

    if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').show();
}